import React from 'react';
import PropTypes from 'prop-types';
import styles from '../vip-shared/separators.module.scss';

const InfoSection = ({
    children,
    title,
    titleRightContentArea,
    showSeparators
}) => {
    return (
        <div
            className={
                showSeparators
                    ? `${styles.smSeparator} ${styles.mdSeparator}`
                    : null
            }>
            <div className={`d-flex ${title ? 'flex-column' : 'flex-row'}`}>
                <div className="d-flex align-items-center mb-2">
                    <h4 className="text-styled mb-0">{title}</h4>
                    {titleRightContentArea}
                </div>
                {children}
            </div>
        </div>
    );
};

InfoSection.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
    titleRightContentArea: PropTypes.node,
    showSeparators: PropTypes.bool
};

InfoSection.defaultProps = {
    showSeparators: true
};

export default InfoSection;
